import { AxiosResponse } from 'axios';
import {all, put, fork, call, take, takeLatest, TakeEffect, CallEffect, PutEffect} from 'redux-saga/effects';

import {

  GET_CITY,
  GET_CITY_SUCCESS,
  GET_CITY_ERROR,
  GET_COMPANIES,
  GET_COMPANIES_SUCCESS,
  GET_COMPANIES_ERROR,
  GET_POSITIONS,
  GET_POSITIONS_SUCCESS,
  GET_POSITIONS_ERROR,
  GET_POSITION,
  GET_POSITION_SUCCESS,
  GET_POSITION_ERROR,
  GET_COMPANY,
  GET_COMPANY_SUCCESS,
  GET_COMPANY_ERROR,
  
} from  './constants';


import {getCompaniesService, getPositionsService, getCityService, getPositionByUrlSlug, getCompanyByUrlSlug} from './services';



function* getCompanies(data: string) {
    try {
      const response: AxiosResponse = yield call(getCompaniesService, data);
      yield put({type: GET_COMPANIES_SUCCESS, response});
    } catch (error) {
      yield put({type: GET_COMPANIES_ERROR, error});
    }
  }

  function* getCompaniesFlow(): Generator<TakeEffect | CallEffect , void, any> {
    while (true) {
      const payload = yield take(GET_COMPANIES);
      const data = payload.employer
      yield call(getCompanies, data);
    }
  }

  function* getPositions(data: string) : Generator<CallEffect | PutEffect  , void, never> { 
      try {
        const response: AxiosResponse = yield call(getPositionsService, data);
        yield put({type: GET_POSITIONS_SUCCESS, response});
      } catch (error) {
        yield put({type: GET_POSITIONS_ERROR, error});
      }
    }

  function* getPositionsFlow(): Generator<TakeEffect | CallEffect , void, any> {
    while (true) {
      const payload = yield take(GET_POSITIONS);
      const data = payload.title
      yield call(getPositions, data);
    }
  }

  function* getCityFlow(action: any) {
    const  city: string = action.city;
    try {
      const response: AxiosResponse = yield call(getCityService, city);
      yield put({type: GET_CITY_SUCCESS, response});
    } catch (error) {
      yield put({type: GET_CITY_ERROR, error});
    }
  }
  
  


  function* getPositionFlow(action: any) {
    const position: string = action.position;
    try {
      const response: AxiosResponse =  yield call(getPositionByUrlSlug, position);
      yield put({type: GET_POSITION_SUCCESS, response});
    } catch (error) {
      yield put({type: GET_POSITION_ERROR, error});
    }
  }

  function* getCompanyFlow(action: any) {
    const  slug: string = action.slug;
    try {
      const response: AxiosResponse = yield call(getCompanyByUrlSlug, slug);
      yield put({type: GET_COMPANY_SUCCESS, response});
    } catch (error) {
      yield put({type: GET_COMPANY_ERROR, error});
    }
  }

export default function* filtersSaga() {
    yield all([
        takeLatest(GET_CITY, getCityFlow),
        takeLatest(GET_POSITION, getPositionFlow),
        takeLatest(GET_COMPANY, getCompanyFlow),
        fork(getCompaniesFlow),
        fork(getPositionsFlow),
    ]);
}
